<template>
  <div class="container-fluid">
    <div class="mt-3 my-md-4">
      <nuxt-link
        :to="localePath('Login')"
        class="arrow-left overview"
      >
        {{ $t('backToLogin') }}
      </nuxt-link>
    </div>
    <div class="content-pad">
      <div class="row mb-3 mb-md-5">
        <div class="col-12">
          <h2 class="text-center">
            {{ $t('registerPage.headline.general') }}
          </h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          v-for="domain in domains"
          :key="domain.name"
          class="col-12 col-md-4 mb-3"
        >
          <dx-icon-box
            animated
            :icon-type="domain.className"
            @click="goToForm(domain.name)"
          >
            <h4 class="mt-2 mt-md-3 mb-2">
              {{ domain.headline }}
            </h4>
            <p class="mb-5">
              {{ domain.infoText }}
            </p>
            <span class="link-bottom mt-5 secondary-link">
              {{ $t('register') }}
            </span>
          </dx-icon-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxIconBox from '~/components/DX-IconBox'

export default {
  name: 'RegistrationSelection',
  meta: {
    isPublic: true,
  },
  components: {
    DxIconBox,
  },
  nuxtI18n: {
    paths: {
      de: '/registration-selection',
      fr: '/inscription-selection',
      if: '/registrazione-selection',
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale.toUpperCase()
    },
    domains() {
      const options = [
        {
          name: 'customer',
          headline: this.$t('registerPage.headline.customer'),
          infoText: this.$t('registerPage.infoText.customer'),
          className: 'customer',
        },
        {
          name: 'lawyer',
          headline: this.$t('damage.lawyer'),
          infoText: this.$t('registerPage.infoText.lawyer'),
          className: 'lawyer',
        },
      ]
      if (this.locale !== 'IT') {
        options.push({
          name: 'broker',
          headline: this.$t('registerPage.headline.partner'),
          infoText: this.$t('registerPage.infoText.partner'),
          className: 'partner',
        })
      }
      return options
    },
  },
  methods: {
    goToForm(name) {
      let routeName = 'SelfService-OfflineRegistration'

      if (name === 'lawyer') {
        routeName = 'LawyerPortal-RegistrationInfo'
      } else if (name === 'broker') {
        routeName = 'PartnerPortal-Registration'
      }

      return this.$router.push({ path: this.localePath(routeName) })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'index';
</style>
